import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

const EcardCategorySearch = {
  categoryId: 0,
  categoryName: "",
  fromMonth: 0,
  toMonth: 0,
  isActive: 2,
  pageNo: 1,
  rowCountPerPage: 10,
  sortBy: "",
};
const ECardUploadSearch = {
  EcardName: "",
  CategoryId: 0,
  IsActive: 2,
  VisibleTo: 0,
  PageNo: 1,
  RowCountPerPage: 10,
  SortBy: "EcardId DESC",
};
const sentEcardSearch = {
  FacilityID: 0,
  InmateResidentId: "",
  PublicFirstName: "",
  PublicLastName: "",
  InmateFirstName: "",
  InmateLastName: "",
  EcardSubject: "",
  EcardSendStartDate: "",
  EcardSendEndDate: "",
  EcardReadStatus: 0,
  PageNo: 1,
  RowCountPerPage: 10,
  SortBy: "Sentdate DESC",
};
// create slice
const name = "eCard";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const eCardAction = { ...slice.actions, ...extraActions };
export const eCardReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    /* E-Card Category */
    EcardCategorySearchData: EcardCategorySearch,
    eCardCategoryList: {},
    categoryAddResponse: {},
    categoryDetail: {},
    categoriesForDropDown: [],

    /* Ecard upload */
    ECardUploadSearchData: ECardUploadSearch,
    uploadECardResponse: {},
    getEcardListResponse: {},
    EcardDetailsForEdit: {},

    /* sent E-Card */
    sentEcardSearchData: sentEcardSearch,
    getSentEcardListResponse: {},
    getSentEcardInfoResponse: {},
  };
}

function createReducers() {
  return {
    resetForm,
    resetCategoryDetail,
    resetECardDetails,
    updateSentEcardSearch,
    resetSentEcardSearch,
    updateEcardSearch,
    updateEcardUploadSearch,
    clearEcardCategorySearch,
    clearECardUploadSearch,
    // clearsentEcardSearch,
  };

  function resetForm(state) {
    state.updateStatusResponse = {};
  }

  function resetCategoryDetail(state) {
    state.categoryDetail = {};
  }

  function resetECardDetails(state) {
    state.EcardDetailsForEdit = {};
  }
  function updateSentEcardSearch(state, action) {
    state.sentEcardSearchData = action?.payload;
  }
  function resetSentEcardSearch(state, action) {
    state.sentEcardSearchData = sentEcardSearch
  }
  function updateEcardSearch(state, action) {
    state.EcardCategorySearchData = action?.payload;
  }
  function updateEcardUploadSearch(state, action) {
    state.ECardUploadSearchData = action?.payload;
  }
  function clearEcardCategorySearch(state, action) {
    state.EcardCategorySearchData = {
      categoryId: 0,
      categoryName: "",
      fromMonth: 0,
      toMonth: 0,
      isActive: 2,
      pageNo: 1,
      rowCountPerPage: 10,
      sortBy: "",
    };
  }
  function clearECardUploadSearch(state, action) {
    state.ECardUploadSearchData = {
      EcardName: "",
      CategoryId: 0,
      IsActive: 2,
      VisibleTo: 0,
      PageNo: 1,
      RowCountPerPage: 10,
      SortBy: "EcardId DESC",
    };
  }
  // function clearsentEcardSearch(state, action) {
  //   state.sentEcardSearchData = {
  //     FacilityID: 0,
  //     InmateResidentId: "",
  //     PublicFirstName: "",
  //     PublicLastName: "",
  //     InmateFirstName: "",
  //     InmateLastName: "",
  //     EcardSubject: "",
  //     EcardSendStartDate: "",
  //     EcardSendEndDate: "",
  //     EcardReadStatus: 2,
  //     PageNo: 1,
  //     RowCountPerPage: 10,
  //     SortBy: "Sentdate DESC",
  //   };
  // }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser`;
  return {
    getECardCategoryList: getECardCategoryList(),
    createEcardCategory: createEcardCategory(),
    getEcardCategoryDetails: getEcardCategoryDetails(),
    getCategoriesForDropDown: getCategoriesForDropDown(),
    uploadECard: uploadECard(),
    getEcardList: getEcardList(),
    getEcardDetailsForEdit: getEcardDetailsForEdit(),
    getSentEcardList: getSentEcardList(),
    getSentEcardInfo: getSentEcardInfo(),
  };

  function getECardCategoryList() {
    return createAsyncThunk(`${name}/eCardCategory`, async (data) => {
      return await fetchWrapper.post(`${baseUrl}/Ecard/LoadCategoryList`, data);
    });
  }

  function createEcardCategory() {
    return createAsyncThunk(`${name}/createEcardCategory`, async (data) => {
      return await fetchWrapper.post(
        `${baseUrl}/Ecard/InsertUpdateCategoryDetails`,
        data
      );
    });
  }
  /* get Details for edit */
  function getEcardCategoryDetails() {
    return createAsyncThunk(
      `${name}/getEcardCategoryDetails`,
      async (CategoryId) => {
        return await fetchWrapper.post(
          `${baseUrl}/Ecard/LoadCategoryDetails?categoryId=${CategoryId}`
        );
      }
    );
  }

  /* get Categories For DropDown*/
  function getCategoriesForDropDown() {
    return createAsyncThunk(
      `${name}/getCategoriesForDropDown`,
      async (data) => {
        return await fetchWrapper.post(
          `${baseUrl}/Ecard/LoadCategoryDropDown`,
          data
        );
      }
    );
  }

  /* upload E-Card*/
  function uploadECard() {
    return createAsyncThunk(`${name}/uploadECard`, async (data) => {
      return await fetchWrapper.post(
        `${baseUrl}/Ecard/InsertUpdateEcardDetails`,
        data
      );
    });
  }

  /* get E-Card list for grid*/
  function getEcardList() {
    return createAsyncThunk(`${name}/getEcardList`, async (data) => {
      return await fetchWrapper.post(
        `${baseUrl}/Ecard/LoadEcardListForAdmin`,
        data
      );
    });
  }

  /* get E-Card details for edit*/
  function getEcardDetailsForEdit() {
    return createAsyncThunk(
      `${name}/getEcardDetailsForEdit`,
      async (cardID) => {
        return await fetchWrapper.post(
          `${baseUrl}/Ecard/LoadEcardDetails?ecardId=${cardID}`
        );
      }
    );
  }

  /* get sent E-Card list*/
  function getSentEcardList() {
    return createAsyncThunk(`${name}/getSentEcardList`, async (data) => {
      return await fetchWrapper.post(
        `${baseUrl}/Ecard/AdminGetAllEcards`,
        data
      );
    });
  }

  /* get sent E-Card info*/
  function getSentEcardInfo() {
    return createAsyncThunk(`${name}/getSentEcardInfo`, async (cardID) => {
      return await fetchWrapper.get(
        `${baseUrl}/Ecard/GetEcardsInfo?EcardID=${cardID}`
      );
    });
  }
}

function createExtraReducers(builder) {
  builder
    //E-Card Category list
    .addCase(extraActions.getECardCategoryList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getECardCategoryList.fulfilled, (state, action) => {
      state.loading = false;
      state.eCardCategoryList = action.payload;
      state.error = null;
    })
    .addCase(extraActions.getECardCategoryList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get ECard Category list";
    })

    //create E-Card Category
    .addCase(extraActions.createEcardCategory.pending, (state, action) => {
      const params = action.meta.arg;
      if (params?.isFrom !== "QuickCategoryAdd") {
        state.loading = true;
        state.error = null;
      }
    })
    .addCase(extraActions.createEcardCategory.fulfilled, (state, action) => {
      const params = action.meta.arg;
      if (params?.isFrom !== "QuickCategoryAdd") {
        state.loading = false;
        state.categoryAddResponse = action.payload;
      }
      state.error = null;
    })
    .addCase(extraActions.createEcardCategory.rejected, (state, action) => {
      const params = action.meta.arg;
      if (params?.isFrom !== "QuickCategoryAdd") {
        state.loading = false;
        state.error =
          action.error.message || "Failed to get ECard Category list";
      }
    })

    //get E-Card Category Details for edit
    .addCase(extraActions.getEcardCategoryDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.getEcardCategoryDetails.fulfilled,
      (state, action) => {
        state.loading = false;
        state.categoryDetail = action.payload;
        state.error = null;
      }
    )
    .addCase(extraActions.getEcardCategoryDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get ECard Category list";
    })

    /* category list for drop down */
    .addCase(extraActions.getCategoriesForDropDown.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.getCategoriesForDropDown.fulfilled,
      (state, action) => {
        state.loading = false;
        state.categoriesForDropDown = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.getCategoriesForDropDown.rejected,
      (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to get ECard Category list";
      }
    )

    /* upload E-Card */
    .addCase(extraActions.uploadECard.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.uploadECard.fulfilled, (state, action) => {
      state.loading = false;
      state.uploadECardResponse = action.payload;
      state.error = null;
    })
    .addCase(extraActions.uploadECard.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get ECard Category list";
    })

    /* E-Card list for grid */
    .addCase(extraActions.getEcardList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getEcardList.fulfilled, (state, action) => {
      state.loading = false;
      state.getEcardListResponse = action.payload;
      state.error = null;
    })
    .addCase(extraActions.getEcardList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get ECard Category list";
    })

    /* get E-card Details For Edit */
    .addCase(extraActions.getEcardDetailsForEdit.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getEcardDetailsForEdit.fulfilled, (state, action) => {
      state.loading = false;
      state.EcardDetailsForEdit = action.payload;
      state.error = null;
    })
    .addCase(extraActions.getEcardDetailsForEdit.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get ECard Category list";
    })

    /* get sent E-card list */
    .addCase(extraActions.getSentEcardList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getSentEcardList.fulfilled, (state, action) => {
      state.loading = false;
      const params = action.meta.arg;
      if (!params?.exportExcel) {
        state.getSentEcardListResponse = action.payload;
      }
      state.error = null;
    })
    .addCase(extraActions.getSentEcardList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get ECard Category list";
    })

    /* get sent E-card info */
    .addCase(extraActions.getSentEcardInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getSentEcardInfo.fulfilled, (state, action) => {
      state.loading = false;
      state.getSentEcardInfoResponse = action.payload;
      state.error = null;
    })
    .addCase(extraActions.getSentEcardInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get ECard Category list";
    });
}
